import {
  CREATE_INVOICE_CYCLES,
  CREATE_INVOICE_CYCLES_FAIL,
  CREATE_INVOICE_CYCLES_SUCCESS,
  CREATE_REPORT_INVOICE,
  CREATE_REPORT_INVOICE_FAIL,
  CREATE_REPORT_INVOICE_SUCCESS,
  DOWNLOAD_REPORT_INVOICE,
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
  EXECUTE_REPORT,
  EXECUTE_REPORT_FAIL,
  EXECUTE_REPORT_SUCCESS,
  GET_REPORT_INVOICE_PROGRESS,
  GET_REPORT_INVOICE_PROGRESS_FAIL,
  GET_REPORT_INVOICE_PROGRESS_SUCCESS,
  LIST_INVOICE_TO_SUMMARY,
  LIST_INVOICE_TO_SUMMARY_FAIL,
  LIST_INVOICE_TO_SUMMARY_SUCCESS,
  LIST_KHDD_INVOICE_TO_SUMMARY,
  LIST_KHDD_INVOICE_TO_SUMMARY_FAIL,
  LIST_KHDD_INVOICE_TO_SUMMARY_SUCCESS,
  RELEASE_INVOICE_CYCLES,
  RELEASE_INVOICE_CYCLES_FAIL,
  RELEASE_INVOICE_CYCLES_SUCCESS,
  REPORT_INVOICE_LIST,
  REPORT_INVOICE_LIST_FAIL,
  REPORT_INVOICE_LIST_RESET,
  REPORT_INVOICE_LIST_SUCCESS,
  RESET_CREATE_INVOICE_CYCLES,
  RESET_CREATE_REPORT_INVOICE,
  RESET_DOWNLOAD_REPORT_INVOICE,
  RESET_EXECUTE_REPORT,
  RESET_GET_REPORT_INVOICE_PROGRESS,
  RESET_LIST_INVOICE_TO_SUMMARY,
  RESET_LIST_KHDD_INVOICE_TO_SUMMARY,
  RESET_RELEASE_INVOICE_CYCLES,
  RESET_TRANSFER_USB_INVOICE_CYCLES,
  SET_COLUMN_VISIBLE_REPORT_INVOICE_LIST,
  SET_COLUMN_VISIBLE_SUMMARY_INVOICE_LIST,
  SUMMARY_INVOICE_LIST,
  SUMMARY_INVOICE_LIST_FAIL,
  SUMMARY_INVOICE_LIST_RESET,
  SUMMARY_INVOICE_LIST_SUCCESS,
  TRANSFER_USB_INVOICE_CYCLES,
  TRANSFER_USB_INVOICE_CYCLES_FAIL,
  TRANSFER_USB_INVOICE_CYCLES_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  type: null,
  //  Danh sách bảng tổng hợp dữ liệu
  invoiceCycles: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  // Phát hành bảng tổng hợp
  releaseInvoiceCyclesData: {
    data: null,
    error: null,
    loading: false,
  },
  // ListInvoiceToSummaryData
  listInvoiceToSummaryData: {
    data: [],
    error: null,
    loading: false,
  },
  // createInvoiceCyclesData
  createInvoiceCyclesData: {
    data: null,
    error: null,
    loading: false,
  },
  // createReportInvoiceData
  createReportInvoiceData: {
    data: null,
    error: null,
    loading: false,
  },
  // reportInvoiceProgress
  reportInvoiceProgress: {
    isStart: false,
    id: null,
    percent: 0,
  },
  // listKHHD
  listKHHD: {
    data: [],
    error: null,
    loading: false,
  },
  //
  transferUSB: {
    data: null,
    error: null,
    loading: false,
  },
  //  Danh sách bảng kê hóa đơn
  reportInvoiceList: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  // Download
  fileDownload: null,
  fileDownloadResponse: null,
  fileDownloadName: null,

  // executeReportData
  executeReportData: {
    data: null,
    error: null,
    loading: false,
  },
};

const summaryInvoiceData = (state = INIT_STATE, action) => {
  const curInvoiceCycles = state.invoiceCycles;
  const curReportInvoiceList = state.reportInvoiceList;
  switch (action.type) {
    // Danh sách bảng tổng hợp
    case SUMMARY_INVOICE_LIST:
      return {
        ...state,
        invoiceCycles: {
          ...curInvoiceCycles,
          loading: true,
          //   params: action.params,
        },
      };
    case SUMMARY_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        invoiceCycles: {
          ...curInvoiceCycles,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case SUMMARY_INVOICE_LIST_FAIL:
      return {
        ...state,
        invoiceCycles: {
          ...curInvoiceCycles,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case SUMMARY_INVOICE_LIST_RESET:
      return {
        ...state,
        invoiceCycles: {
          ...curInvoiceCycles,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Phát hành bảng tổng hợp
    case RELEASE_INVOICE_CYCLES:
      return {
        ...state,
        releaseInvoiceCyclesData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case RELEASE_INVOICE_CYCLES_SUCCESS:
      return {
        ...state,
        releaseInvoiceCyclesData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case RELEASE_INVOICE_CYCLES_FAIL:
      return {
        ...state,
        releaseInvoiceCyclesData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_RELEASE_INVOICE_CYCLES:
      return {
        ...state,
        releaseInvoiceCyclesData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    // Tạo bảng tổng hợp
    case CREATE_INVOICE_CYCLES:
      return {
        ...state,
        createInvoiceCyclesData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_INVOICE_CYCLES_SUCCESS:
      return {
        ...state,
        createInvoiceCyclesData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case CREATE_INVOICE_CYCLES_FAIL:
      return {
        ...state,
        createInvoiceCyclesData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_INVOICE_CYCLES:
      return {
        ...state,
        createInvoiceCyclesData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    // listInvoiceToSummary
    case LIST_INVOICE_TO_SUMMARY:
      return {
        ...state,
        listInvoiceToSummaryData: {
          loading: true,
          data: [],
          error: null,
        },
      };
    case LIST_INVOICE_TO_SUMMARY_SUCCESS:
      return {
        ...state,
        listInvoiceToSummaryData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case LIST_INVOICE_TO_SUMMARY_FAIL:
      return {
        ...state,
        listInvoiceToSummaryData: {
          loading: false,
          data: [],
          error: action.error,
        },
        type: action.type,
      };
    case RESET_LIST_INVOICE_TO_SUMMARY:
      return {
        ...state,
        listInvoiceToSummaryData: {
          loading: false,
          data: [],
          error: action.error,
        },
        type: action.type,
      };
    //
    // LIST_KHDD_INVOICE_TO_SUMMARY
    case LIST_KHDD_INVOICE_TO_SUMMARY:
      return {
        ...state,
        listKHHD: {
          loading: true,
          data: [],
          error: null,
        },
      };
    case LIST_KHDD_INVOICE_TO_SUMMARY_SUCCESS:
      return {
        ...state,
        listKHHD: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case LIST_KHDD_INVOICE_TO_SUMMARY_FAIL:
      return {
        ...state,
        listKHHD: {
          loading: false,
          data: [],
          error: action.error,
        },
        type: action.type,
      };
    case RESET_LIST_KHDD_INVOICE_TO_SUMMARY:
      return {
        ...state,
        listKHHD: {
          loading: false,
          data: [],
          error: action.error,
        },
        type: action.type,
      };
    //
    case TRANSFER_USB_INVOICE_CYCLES:
      return {
        ...state,
        transferUSB: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case TRANSFER_USB_INVOICE_CYCLES_SUCCESS:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };

    case TRANSFER_USB_INVOICE_CYCLES_FAIL:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: action.error,
          loading: false,
        },
      };
    case RESET_TRANSFER_USB_INVOICE_CYCLES:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };
    // Danh sách bảng kê hóa đơn
    case REPORT_INVOICE_LIST:
      return {
        ...state,
        reportInvoiceList: {
          ...curReportInvoiceList,
          loading: true,
          //   params: action.params,
        },
      };
    case REPORT_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        reportInvoiceList: {
          ...curReportInvoiceList,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case REPORT_INVOICE_LIST_FAIL:
      return {
        ...state,
        reportInvoiceList: {
          ...curReportInvoiceList,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case REPORT_INVOICE_LIST_RESET:
      return {
        ...state,
        reportInvoiceList: {
          ...curReportInvoiceList,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Tạo bảng kê
    case CREATE_REPORT_INVOICE:
      return {
        ...state,
        createReportInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
        reportInvoiceProgress: {
          isStart: true,
          id: null,
          percent: 0,
        },
      };
    case CREATE_REPORT_INVOICE_SUCCESS:
      return {
        ...state,
        createReportInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case CREATE_REPORT_INVOICE_FAIL:
      return {
        ...state,
        createReportInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_REPORT_INVOICE:
      return {
        ...state,
        createReportInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    // tiến trình bảng kê
    case GET_REPORT_INVOICE_PROGRESS:
      let isStartVariable = state.reportInvoiceProgress.isStart;
      if (action.isStartByViewDetail) {
        isStartVariable = true;
      }
      return {
        ...state,
        reportInvoiceProgress: {
          isStart: isStartVariable,
          id: action.id,
          percent: state.reportInvoiceProgress.percent,
        },
      };
    case GET_REPORT_INVOICE_PROGRESS_SUCCESS:
      let isStart = state.reportInvoiceProgress.isStart;
      if (action.data === 100) {
        isStart = false;
      }
      return {
        ...state,
        reportInvoiceProgress: {
          isStart: isStart,
          id: state.reportInvoiceProgress.id,
          percent: action.data,
        },
        type: action.type,
      };

    case GET_REPORT_INVOICE_PROGRESS_FAIL:
      return {
        ...state,
        reportInvoiceProgress: {
          isStart: false,
          id: null,
          percent: 0,
        },
        type: action.type,
      };
    case RESET_GET_REPORT_INVOICE_PROGRESS:
      return {
        ...state,
        reportInvoiceProgress: {
          isStart: false,
          id: null,
          percent: 0,
        },
        type: action.type,
      };
    // DOWNLOAD_REPORT_INVOICE
    case DOWNLOAD_REPORT_INVOICE:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
        error: action.error,
      };
    case DOWNLOAD_REPORT_INVOICE_SUCCESS:
      return {
        ...state,
        type: action.type,
        fileDownload: action.fileDownload,
        fileDownloadResponse: action.fileDownloadResponse,
        fileDownloadName: action.fileDownloadName,
      };
    case DOWNLOAD_REPORT_INVOICE_FAIL:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
        error: action.error,
      };
    case RESET_DOWNLOAD_REPORT_INVOICE:
      return {
        ...state,
        type: null,
        error: null,
        // fileDownload: null,
        // fileDownloadResponse: null,
        // fileDownloadName: null,
      };

    //
    case SET_COLUMN_VISIBLE_SUMMARY_INVOICE_LIST:
      curInvoiceCycles.columnsVisible[action.field] = action.value;
      return {
        ...state,
        invoiceCycles: {
          ...curInvoiceCycles,
        },
      };
    case SET_COLUMN_VISIBLE_REPORT_INVOICE_LIST:
      curReportInvoiceList.columnsVisible[action.field] = action.value;
      return {
        ...state,
        reportInvoiceList: {
          ...curReportInvoiceList,
        },
      };
    // EXECUTE_REPORT
    case EXECUTE_REPORT:
      return {
        ...state,
        executeReportData: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case EXECUTE_REPORT_SUCCESS:
      return {
        ...state,
        type: action.type,
        executeReportData: {
          data: null,
          error: null,
          loading: false,
        },
      };

    case EXECUTE_REPORT_FAIL:
      return {
        ...state,
        type: action.type,
        executeReportData: {
          data: null,
          error: action.error,
          loading: false,
        },
      };
    case RESET_EXECUTE_REPORT:
      return {
        ...state,
        type: action.type,
        executeReportData: {
          data: null,
          error: null,
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default summaryInvoiceData;
